<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
                <li><a href="#">账户设置</a></li>
                <li><a href="#">用户信息</a></li>
            </ul>
        </div>

        <div id="usual1" class="usual"> 
            <div class="formbody">
                <div class="formtitle"><span>个人基本信息</span></div>
                <ul class="forminfo">
                    <li>
                        <label>用户名</label>
                        <div class="vocation">
                            <input v-model="nickname" type="text" class="dfinput" />
                        </div>
                        <i class="toolbars lh33" style='margin-left: 20px;'>5-7位，不能输入中文</i>
                    </li>
                    <li>
                        <label>分机1(手机)</label>
                        <div class="vocation">
                            <input v-model="mobile" type="text" class="dfinput" />
                        </div>
                        <div class="buttonupload  click left" style="margin-left:20px;" @click="checkmobile('mobile')">电话验证</div>
                        <div class="buttonupload  click left" @click="checkmobile('sms')">短信验证</div>
                        <i  class="toolbars lh33" style='margin-left: 20px;'>分机1必须是您的手机号码</i>
                    </li>
                    <li>
                        <label>分机3/门牌号</label>
                        <div class="vocation">
                            <input v-model="account" type="text" class="dfinput" readonly/>
                        </div>
                        <i class="toolbars lh33" style='margin-left: 20px;'>平台自动编号，分机3为平台自动编号，即门牌号</i>
                    </li>
                    <li>
                        <label>邮箱</label>
                        <div class="vocation">
                            <input v-model="email" type="text" class="dfinput" />
                        </div>
                        <div class="buttonupload  click left" style="margin-left:20px;" @click="checkemail()">修改/验证邮箱</div>
                        <template v-if="user.ischeckEmail == 0">
                            <i class="toolbars lh33">邮箱未验证</i>
                            <i class="toolbars lh33" style='margin-left: 20px;'>请及时到邮箱收取验证邮件</i>
                        </template>
                        <template v-if="user.ischeckEmail == 1">
                            <i class="toolbars lh33">邮箱已验证</i>
                        </template>
                    </li>
                    <li>
                        <label>联系地址</label>
                        <div class="vocation">
                            <input v-model="address" type="text" class="dfinput" />
                        </div>
                    </li>
                    <li>
                        <label>QQ</label>
                        <div class="vocation">
                            <input v-model="qq" type="text" class="dfinput" placeholder="qq号绑定时修改" />
                        </div>
                        <template v-if="qqflag == 'yes'">
                            <div class="buttonupload  click left" style="margin-left:20px;" @click="jbqq()">QQ账号解绑</div>
                        </template>
                        <template v-else-if="qqflag == 'no'">
                            <div class="buttonupload  click left" style="margin-left:20px;" @click="bindqq()">QQ账号绑定</div>
                        </template>
                        <i class="toolbars lh33">绑定QQ后免密快速登录</i>
                    </li>
                    <li>
                        <label>MSN</label>
                        <div class="vocation">
                            <input v-model="msn" type="text" class="dfinput" />
                        </div>
                    </li>

                    <li>
                        <label>旺旺</label>
                        <div class="vocation">
                            <input v-model="ww" type="text" class="dfinput" />
                        </div>
                    </li>
                    <li>
                        <label>单位名称</label>
                        <div class="vocation">
                            <input v-model="company" type="text" class="dfinput" />
                        </div>
                    </li>
                    <li>
                        <label>所在行业</label>
                        <div class="vocation">
                            <input v-model="job" type="text" class="dfinput" />
                        </div>
                    </li>
                    <li>
                        <label>单位电话</label>
                        <div class="vocation">
                            <input v-model="comtelephone" type="text" class="dfinput" />
                        </div>
                    </li>
                    <li>
                        <label>单位地址</label>
                        <div class="vocation">
                            <input v-model="comaddress" type="text" class="dfinput" />
                        </div>
                    </li>
                    <li>
                        <label>邮编</label>
                        <div class="vocation">
                            <input v-model="compostno" type="text" class="dfinput" />
                        </div>
                    </li>
                    <li>
                        <label>&nbsp;</label>
                        <input class="sure" type="button" value="保存并提交" @click="update()">
                    </li>
                </ul>
                <div class="jian">&nbsp;</div>
                <div class="welinfo">
                    <span><img src="@/images/dp.png" alt="提醒" /></span>
                    <b>手机电话验证步骤</b>
                </div>
                <ul class="infolist">
                    <li>请确认您在要验证的电话旁边，可以接听/查看该电话</li>
                    <li> 1、填写号码，提交 （固话和小灵通前请加区号） </li> 
                    <li>2、电话振铃，接听，记录验证码，挂电话/或收到短信，查看 </li>
                    <li>3、填写验证码，再次提交 </li>
                    <li>本公司仅根据用户登录名和密码来确认使用本服务的用户身份。用户应妥善保管用户登录名及密码，并对其使用及其遗失自行承担责任。 用户填写的资料，包括手机、邮箱\QQ\双方同意的第三方账号登录等需真实有效，如有变更应及时主动设置调整、重新绑定，否则本系统据此认定或验证用户身份，包括但不限于身份验证、密码取回、造成账户余额被盗用等不承担任何责任；用户还需为此疏忽产生的其他不良后果承担责任，包括但不限于被盗用而发送有违规有害信息行为后果 。</li>
                </ul>
            </div>

            <div class="tip tip1" style="height:200px;">
                <div class="tiptop"><span>号码验证</span><a></a></div>
            
                <div class="tipinfo" style="height:60px;">
                    验证码：<input name="" v-model="validate" type="text" class="scinput" style="width:200px;"/>
                    
                </div>
            
                <div class="tipbtn">
                    <input name="" type="button"  class="sure" @click="yanzheng()" value="确定" />&nbsp;
                    <!-- <input name="" type="button"  class="cancel" @click="close()" value="取消" /> -->
                </div>    
            </div>

            <!-- <div  v-show="checkValidateShow" style="position: fixed; width:100%; height:100%; z-index:9999; background:rgb(51, 51, 51); opacity: 0.6; 
                top: 0; left: 0;display: block;"/>
            <div class="tip" v-show="checkValidateShow" style="display: block; margin-top: 150px;width:560px;">
                <div class="tiptop"><span>号码验证</span></div>
                <table class="tablelist">
                    <tr>
                        <td>
                            <span style="color:cornflowerblue; font-size: 16px; margin-top: 10px;">
                                验证码：
                                <input type="text" v-model="validate" style="border: cornflowerblue solid 0.1px;height:25px; margin-left: 5px; width:80px;padding-left:8px;">
                                <input type="button" value="  验  证  " style="border: solid 0.2px;padding: 5px 3px; 
                                    margin-left: 15px;cursor: pointer;" @click="yanzheng()">
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <span style="color:coral; margin:10px 0px 0px 0px;">
                                根据所接听电话或短信信息里的验证码，输入验证码，提交验证！(本次验证不产生任何费用)
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <span style="margin:10px 0px 20px 0px;">
                                <img src="@/images/dp.png" alt="提醒"/>
                                <label class="tiptop" style="cursor: text;font-size: 14px;">等待会，接听电话或查看短信，记录验证码，输入验证码，验证完成！</label>
                            </span>
                        </td>
                    </tr>
                </table>
            </div> -->

            <!-- <div  v-show="checkValidateSuccess" style="position: fixed; width:100%; height:100%; z-index:9999; background:rgb(51, 51, 51); opacity: 0.6; 
                top: 0; left: 0;display: block;"/>
            <div class="tip" v-show="checkValidateSuccess" style="display: block; margin-top: 150px;width:560px;">
                <div class="tiptop"><span>号码验证</span></div>
                <table class="tablelist">
                    <tr>
                        <td>
                            <span style="color:cornflowerblue; font-size: 16px; margin-top: 10px;text-align: center;margin: 10px 0px 10px 0px ;">
                                恭喜，手机验证成功!
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type="button" value="  返  回  " style="border: solid 0.2px;padding: 10px 10px; 
                                margin-left: 25%;cursor: pointer;margin-bottom: 20px;" @click="operation('1')">
                            <input type="button" value="填写更多详细信息" style="border: solid 0.2px;padding: 10px 10px; 
                                margin-left: 12%;cursor: pointer;margin-bottom: 20px;" @click="operation('2')">
                        </td>
                    </tr>
                </table>
            </div> -->

            <div  v-show="showqq" style="position: fixed; width:100%; height:100%; z-index:9999; background:rgb(51, 51, 51); opacity: 0.6; 
                top: 0; left: 0;display: block;"/>
            <div class="tip" v-show="showqq" style="display: block;width: 800px;height: 600px;z-index:10000;">
                <iframe :src="showqq_url" style="width: 800px;height: 600px;" v-show="showqq"> 
                </iframe>
            </div>

        </div>
    </div>
</template>

<script>
import cookie from '@/components/cookie.vue'
import { isMobil, is_email, is_number } from '@/assets/js/checkFunction.js'

export default {
    data() {
        return {
            nickname: '',
            mobile: '',
            account: '',
            email: '',
            address: '',
            qq: '',
            msn: '',
            ww: '',
            company: '',
            job: '',
            comtelephone: '',
            comaddress: '',
            compostno: '',
            user: '',
            checkValidateShow: false,
            validate: '',
            checkValidateSuccess: false,
            qqflag: '',
            weixinflag: '',
            showqq_url: '',
            showqq: false,
        }
    },
    components : {
        'v-cookie' : cookie,
    },
    mounted() {
        this.getpersoninfo()
    },
    methods: {
        getpersoninfo() {
            var that = this
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + "/person/personinfo.json",
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'token': this.GLOBAL.token,
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.nickname = res.data.user.nickname
                    that.mobile = res.data.user.mobile
                    that.account = res.data.user.account
                    that.email = res.data.user.email
                    that.address = res.data.user.address
                    that.qq = res.data.user.qq
                    that.msn = res.data.user.msn
                    that.ww = res.data.user.ww
                    that.company = res.data.user.company
                    that.job = res.data.user.job
                    that.comtelephone = res.data.user.comtelephone
                    that.comaddress = res.data.user.comaddress
                    that.compostno = res.data.user.compostno
                    that.user = res.data.user
                    that.qqflag = res.data.qqflag
                }
                else
                {
                    alert(res.data.msg)
                    return false
                }
            })
        },
        update() {
            if(this.nickname == '')
            {
                this.$alert("用户名不能为空")
                return false
            }
            var that = this
            // let param = {'nickname': this.nickname, 'mobile': this.mobile, 'account': this.account, 'email': this.email, 'address': this.address, 'qq': this.qq, 
            //     'msn': this.msn, 'ww': this.ww, 'company': this.company, 'job': this.job, 'comtelephone': this.comtelephone, 'comaddress': this.comaddress, 'compostno': this.compostno}
            let param = {'nickname': this.nickname, 'account': this.account, 'address': this.address, 'msn': this.msn, 'ww': this.ww, 'company': this.company, 
                'job': this.job, 'comtelephone': this.comtelephone, 'comaddress': this.comaddress, 'compostno': this.compostno}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + "/person/updatepersoninfo.json",
                data: param,
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'token': this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    // that.$alert("用户信息修改成功!")
                    that.$message({
                        duration: 4000,
                        showClose: true,
                        type: 'warning',
                        message: '用户信息修改成功!'
                    })
                    that.getpersoninfo()
                }
                else
                {
                    // that.$alert(res.data.msg)
                    // return false;
                    that.$message({
                        type: 'warning',
                        message: res.data.msg
                    })
                    return false
                }
            })
        },
        checkmobile(type) {
            if(this.mobile == '')
            {
                this.$alert("验证的手机号不能为空!")
                return false;
            }
            if(!isMobil(this.mobile))
            {
                this.$alert("手机号码不符合规定!")
                return false;
            }
            if(this.mobile.length > 11)
            {
                this.$alert("请输入11位符合规定的手机号!")
                return false;
            }
            var that = this
            let param = {'mobile': this.mobile, 'checkModel': type}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + "/user/sendmobilecode.json",
                data: param,
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'token': this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    if(that.mobile == that.user.mobile)
                    {
                        that.$alert("验证成功!")
                        that.getpersoninfo()
                    }
                    else
                    {
                        $(".tip1").fadeIn(200);
                        $(".tiptop a").click(function(){
                            $(".tip1").fadeOut(200);
                        })
                    }
                }
                else
                {
                    that.$alert(res.data.msg)
                    return false;
                }
            })
        },
        yanzheng() {
            var that = this
            let param = {"loginSign":"", "verifyCode":this.validate,"verifyType":"mobilecheck"}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + "/user/checkmobilecode.json",
                data: param,
                headers: {
                    'Content-type': 'application/json;charset=UTF-8',
                    'token': this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    alert("验证码成功!");
                    that.close();
                }
                else
                {
                    alert(res.data.msg)
                    return false;
                }
            })
        },
        close(){
            $(".tip1").fadeOut(200);
        },
        operation(type) {
            this.checkValidateSuccess = false
            if(type == '1')
            {
                this.$router.push('/desktop')
            }
            else if(type == '2')
            {
                that.getpersoninfo()
            }
        },
        checkemail() {
            if(this.email == '')
            {
                alert("邮箱地址不能为空!")
                return false;
            }
            if(!is_email(this.email))
            {
                alert("邮箱地址不符合规定！")
   			    return false;
            }
            var that = this
            let param = {'email': this.email}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + "/person/updateemail.json",
                data: param,
                headers: {
                    'Content-type': 'application/json;charset=UTF-8',
                    'token': this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    alert(res.data.msg)
                    that.getpersoninfo()
                }
                else
                {
                    alert(res.data.msg)
                    return false;
                }
            })
        },
        bindqq() {
            if(this.qq.trim().length < 1)
            {
                this.$alert("qq号不能为空!")
                return false;
            }
            var that = this
            let param = {'qq': this.qq}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + "/person/bindqq.json",
                data: param,
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'token': this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.$router.push({
                        // path: 'qqtoken',
                        // query: {'appid': res.data.appid, 'appkey': res.data.appkey, 'callback': res.data.callback}
                        path: 'qqbind'
                    })
                }
                else
                {
                    that.$message({
                        type: 'error',
                        message: res.data.msg
                    });
                    // that.$alert(res.data.msg)
                    return false;
                }
            })
            // this.$confirm("您确认绑定QQ：" + this.qq + " 吗？", '提示', {
            //     confirmButtonText: '确定', 
            //     cancelButtonText: '取消',                               
            //     type: 'warning'
            // }).then( () => {
            //     if(this.qq.trim().length < 1)
            //     {
            //         this.$alert("qq号不能为空!")
            //         return false
            //     }
            //     var that = this
            //     let param = {'qq': this.qq}
            //     this.$ajax({
            //         method: 'post',
            //         url: this.GLOBAL.serverSrc + "/person/bindqq.json",
            //         data: param,
            //         headers: {
            //             'Content-Type': 'application/json;charset=UTF-8',
            //             'token': this.GLOBAL.token
            //         }
            //     }).then(function(res) {
            //         if('0000000' == res.data.code)
            //         {
            //             that.$router.push({
            //                 path: 'qqtoken',
            //                 query: {'appid': res.data.appid, 'appkey': res.data.appkey, 'callback': res.data.callback}
            //             })
            //             // var url = "https://graph.qq.com/oauth2.0/authorize?response_type=&client_id=" + res.data.appid + "&redirect_uri=http://www.2office.cn/qq/qqtoken.jsp&state=qqlogin"
            //             // // alert(url)
            //             // window.open(url, 'rightFrame')
                        
            //             // that.showqq_url = "https://graph.qq.com/oauth2.0/authorize?response_type=&client_id=" + res.data.appid + "&redirect_uri=http://www.2office.cn/qq/qqtoken.jsp&state=qqlogin"
            //             // that.showqq = true
            //         }
            //         else
            //         {
            //             that.$message({
            //                 type: 'error',
            //                 message: res.data.msg
            //             });
            //             // that.$alert(res.data.msg)
            //             return false;
            //         }
            //     })
            // }).catch( () => {
            //     this.$message({
            //         duration: 2000,
            //         showClose: true,
            //         type: 'error',
            //         message: '已取消'
            //     });
            //     // this.$message.error("已取消")
            // });
        },
        jbqq() {
            this.$confirm("您确定解绑qq吗？", '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then( () => {
                // alert('jbqq')
                var that = this
                this.$ajax({
                    method: 'post',
                    url: this.GLOBAL.serverSrc + "/person/qqjb.json",
                    headers: {
                        'Content-Type': "application/json;charset=utf-8",
                        'token': this.GLOBAL.token
                    }
                }).then(function(res) {
                    if('0000000' == res.data.code)
                    {
                        that.$alert('解绑成功', '提示', {
                            confirmButtonText: '确定'
                        })
                        that.getpersoninfo();
                    }
                })
            }).catch( () => {
                this.$message({
                    type: 'info',
                    message: '已取消QQ解绑'
                })
            })
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/person/personinfo.vue